"use strict";
/**
 * Shared socket event for all kind of Data manipulation operations
 * (e.g. Equipment details, Add defects, Document link, etc)
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.EVENT_CONNECT = exports.EVENT_DISCONNECT = exports.EVENT_COMPLETE = exports.EVENT_UPDATE = void 0;
/**
 * Event emitted when there's a data change
 */
exports.EVENT_UPDATE = "update";
/**
 * Event emitted when the purpose of the socket is completed
 */
exports.EVENT_COMPLETE = "complete";
/**
 * Socket disconnect event
 */
exports.EVENT_DISCONNECT = "disconnect";
/**
 * Socket connect event
 */
exports.EVENT_CONNECT = "connect";
//# sourceMappingURL=socket-io-commons.js.map